import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getGlobalConfiguration } from '../ActionCreators'
import { ORG_ENV, VNCONFIGS_GLOBAL_REQUIRED } from '../../constants'

export const VNGlobalConfigurations = () => {

  const dispatch = useDispatch()

  const [configurationFetched, setConfigurationFetched] = useState(false)

  useEffect(() => {
    if (VNCONFIGS_GLOBAL_REQUIRED && !configurationFetched) {
      setConfigurationFetched(true)
      dispatch(getGlobalConfiguration(ORG_ENV, 'public', 'runtime'))
    }
  }, [configurationFetched, dispatch])

  return (
    <span></span>
  )
}
